module.exports = __webpack_public_path__ + "assets/img/11.ea5b7910.png";